import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { Formik, Field as Fieldmik } from "formik";
import { Form as FormUi, Segment, Button, Container } from "semantic-ui-react";
import * as yup from "yup";
import { Checkbox } from "formik-semantic-ui";
import moment from "moment";
import Axios from "axios";

import AddTitleBar from "../../components/titleBar/addTitleBar";
import LoadingPlaceholder from "../placeholder/loadingPlaceholder";
import APP_CONSTANTS from "../../config/constants";
import UploadFile from "../formikInput/fileUpload";
import SupportingDoc from "./supportingDoc";
import APP_CONSTANT from "../../config/constants";

//Inputs
import { DateData } from "../formikInput/date";

//Add-Product
import AddProduct from "../purchaseOrder/addProduct";
import ActivePurchaseOrder from "./activePurchaseOrder";

//Dropdowns
import PurchaseOrderVendorDropdown from "../dropdowns/purchaseOrderVendorDropdown";
import PurchaseOrderBranchDropdown from "../dropdowns/purchaseOrderBranchDropdown";
import BranchDropdown from "../dropdowns/branchDropdown";
import VendorVehicleDropdown from "../dropdowns/vendorVehicleDropdown";

//Actions
import { getBills, updateBill } from "../../redux/actions/billActions";
import {
  getMappedVendorPurchaseOrder,
  getVendorPurchaseOrder,
  updatePurchaseOrder,
} from "../../redux/actions/purchaseOrderActions";
import cogoToast from "cogo-toast";
import { MyTextArea } from "../formikInput/input";
import CheckedPurchaseOrder from "./checkedPurchaseOrder";
import { hasMinValueForBillDate } from "../../config/const";

const EditBill = (props) => {
  const {
    getBills,
    updateBill,
    getVendorPurchaseOrder,
    updatePurchaseOrder,
    vendorPurchaseOrderData,
    vendorPurchaseOrderPagination,
    vendorPurchaseOrderLoading,
    billData,
    billLoading,
  } = props;

  //State
  const [activateManualPO, setActivateManualPO] = useState(false);
  const [vehicleData, setVehicleData] = useState([]);
  const [vendorDetails, setVendorDetails] = useState({});
  const [stateData, setStateData] = useState([]);
  const [gst, setGst] = useState("");
  const [branchData, setBranchData] = useState([]);
  const [initialize, setInitialize] = useState(false);
  const [vendorState, setVendorState] = useState("");
  const [vendorStateId, setVendorStateId] = useState("");
  const [branchCode, setBranchCode] = useState("");
  const [masterState, setMasterState] = useState("");
  const [editLoading, setEditLoading] = useState(false);
  const [editMappedPOLoading, setEditMappedPOLoading] = useState(false);
  const [supportDocArray, setSupportDocArray] = useState([]);
  const [purchaseOrderCurrentPage, setPurchaseOrderCurrentPage] = useState(1);
  const [mappedPurchaseOrderCurrentPage, setMappedPurchaseOrderCurrentPage] = useState(1);
  const [mappedPOPagination, setMappedPOPagination] = useState()
  const [searchText, setSearchText] = useState("");
  const [mappedSoArray, setMappedSoArray] = useState([])
  const [activePOData, setActivePOData] = useState([]);

  //UseEffect

  useEffect(() => {
    let activePOData = [];

    vendorPurchaseOrderData &&
      billData &&
      vendorPurchaseOrderData.map((o, i) => {
        let temp = {};

        function containsPoId(obj, list) {
          var i;
          for (i = 0; i < list?.length; i++) {
            if (list[i].poId === obj.poId) {
              return true;
            }
          }

          return false;
        }
          temp.checkbox = containsPoId(o, billData[0].bill_po_mapping);
          temp.isEditable = containsPoId(o, billData[0].bill_po_mapping);
          temp.poId = o.poId;
          temp.poReferenceNo = o.poReferenceNo;
          temp.vendorCode = o.vendorId;
          temp.branchCode = o.branchId;
          temp.orderNo = o.orderNo;
          temp.vehicleNo = o.vehicleId;
          temp.poQuantity = o.poQuantity;
          temp.poAmount = o.poAmount;
          temp.poNumber = o.poNumber;
          temp.expectedDeliveryDate = o.expectedDeliveryDate
            ? o.expectedDeliveryDate
            : "";
          temp.sgstAmount = o.sgstAmount;
          temp.cgstAmount = o.cgstAmount;
          temp.igstAmount = o.igstAmount;
          temp.adjustment = o.adjustment;
          temp.totalOrderAmt = o.totalOrderAmt;
          temp.remarks = o.remarks;
          temp.gstTaxType = o.gstTaxType;
          temp.poDate = o.poDate;
          temp.tdsAmount = o.tdsAmount;
          temp.taxableAmount = o.taxableAmount;
          temp.totalDiscount = o.totalDiscount;

          activePOData[i] = temp;
      });
      setActivePOData(activePOData);
  }, [vendorPurchaseOrderData]);

  useEffect(() => {
    const vendorData = {
      vendorCode: props.location.state.vendorCode,
      billId: props.location.state.billId,
    };
    setTimeout(() => {
      setEditLoading(true)

      let getMappedPo = getMappedVendorPurchaseOrder(vendorData, vendorData.vendorCode, 1, "", '', true, vendorData.billId).then(
        (res) => {
          setEditLoading(false);
          setMappedSoArray(res.data)
          setMappedPOPagination(res.pagination)
        }
      );
    }, 500);
  }, [])

  useEffect(() => {
    const billRefNo = props.location.state.id;

    const vendorData = {
      vendorCode: props.location.state.vendorCode,
      billId: props.location.state.billId,
    };
    const vendorId = props.location.state.vendorId;
    const edit = true;
    setEditLoading(true);
    getBills(billRefNo, props.location.state.billId);

    getVendorPurchaseOrder(vendorData, vendorData.vendorCode, 1, "", edit,true).then(
      () => {
        setEditLoading(false);
      }
    );

    let token = localStorage.getItem("apiToken");
    let userId = localStorage.getItem("userId");
    let customerNo = localStorage.getItem("customerNo");

    let vehdata = JSON.stringify({
      customerNumber: customerNo,
      userId: userId,
      customer_no: customerNo,
      user_id: userId,
      customerNo: customerNo,
    });

    Axios.post(
      `${APP_CONSTANTS.BASE_URL}masters/vendorMaster/vehicles/${vendorId}`,
      vehdata,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    )
      .then((response) => {
        setVehicleData(response.data.resultSet);
      })
      .catch((error) => console.log(error));

    Axios.get(
      `${APP_CONSTANTS.BASE_URL}/masters/stateMaster?customerNumber=${customerNo}&userId=${userId}`,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    )
      .then((response) => {
        setStateData(response.data.resultSet);
      })
      .catch((error) => console.log(error));

    let supportBillData = JSON.stringify({
      customerNumber: customerNo,
      userId: userId,
      customer_no: customerNo,
      user_id: userId,
      customerNo: customerNo,
      billId: vendorData.billId.toString(),
    });

    Axios.post(
      `${APP_CONSTANTS.BASE_URL}purchase/bill/getBillSupportingDocumentType`,
      supportBillData,
      {
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: token,
        },
      }
    )
      .then((response) => {
        setSupportDocArray(response.data.data);
      })
      .catch((error) => console.log(error));
  }, [getBills]);

  const handlePaginationChange = (activePage) => {
    setPurchaseOrderCurrentPage(activePage);
    getPoData(activePage, searchText);
  };

  const handleSearchString = (searchString) => {
    setSearchText(searchString.toString());
    setPurchaseOrderCurrentPage(1)
    getPoData(1, searchString);
  };

  const getPoData = (activePage, searchString) => {
    setEditLoading(true);
    const edit = true;
    const vendorData = {
      vendorCode: props.location.state.vendorCode,
      billId: props.location.state.billId,
    };

    getVendorPurchaseOrder(
      vendorData,
      vendorData.vendorCode,
      activePage,
      searchString,
      edit,
      true
    ).then(() => {
      setEditLoading(false);
    });
  };
  const handleMappedPOPaginationChange = (activePage) => {
    setMappedPurchaseOrderCurrentPage(activePage);
    getMappedPoData(activePage, searchText);
  };
  const getMappedPoData = (activePage, searchString) => {
    setEditMappedPOLoading(true);
    const edit = true;
    const vendorData = {
      vendorCode: props.location.state.vendorCode,
      billId: props.location.state.billId,
    };

  getMappedVendorPurchaseOrder(vendorData, vendorData.vendorCode, activePage, "", '', true,vendorData.billId).then(
      (res) => {
        setEditMappedPOLoading(false);
        setMappedPOPagination(res.pagination)
        setMappedSoArray(res.data)
      }
    );
  };

    const vendorData = {
      vendorCode: props.location.state?.vendorCode,
      billId: props.location.state?.billId,
    };



      let mappedPOData = [];

      mappedSoArray &&      
        mappedSoArray.map((o, i) => {
          let temp = {};
  
          function containsPoId(obj, list) {
            var i;
            for (i = 0; i < list?.length; i++) {
              if (list[i].poId === obj.poId) {
                return true;
              }
            }
  
            return false;
          }
  
          temp.checkbox = containsPoId(o, billData[0].bill_po_mapping);
          temp.isEditable = containsPoId(o, billData[0].bill_po_mapping);
          temp.poId = o.poId;
          temp.poReferenceNo = o.poReferenceNo;
          temp.vendorCode = o.vendorId;
          temp.branchCode = o.branchId;
          temp.vehicleNo = o.vehicleId;
          temp.orderNo = o.orderNo;
          temp.poQuantity = o.poQuantity;
          temp.poAmount = o.poAmount;
          temp.poNumber = o.poNumber;
          temp.expectedDeliveryDate = o.expectedDeliveryDate
            ? o.expectedDeliveryDate
            : "";
          temp.sgstAmount = o.sgstAmount;
          temp.cgstAmount = o.cgstAmount;
          temp.igstAmount = o.igstAmount;
          temp.adjustment = o.adjustment;
          temp.totalOrderAmt = o.totalOrderAmt;
          temp.remarks = o.remarks;
          temp.gstTaxType = o.gstTaxType;
          temp.poDate = o.poDate;
          temp.tdsAmount = o.tdsAmount;
          temp.taxableAmount = o.taxableAmount;
          temp.totalDiscount = o.totalDiscount;
  
          mappedPOData[i] = temp;
        });

    let tempDocArray = [];
    supportDocArray &&
      supportDocArray.map((doc, docIndex) => {
        let temp = {};
        temp.billId = doc.billId;
        temp.supportingDocumentTypeName = doc.supportingDocumentTypeName;
        temp.supportingDocumentTypeId = doc.supportingDocumentTypeId;
        temp.fileUrl = "";
        temp.fileDownload = doc.fileUrl;
        temp.isDeleted = doc.isDeleted;
        temp.billSupportingDocumentTypeMappingId =
          doc.billSupportingDocumentTypeMappingId;

        return (tempDocArray[docIndex] = temp);
      });

    //Formik
    const initialValues = {
      vendorId: billData ? billData[0].vendorId : "",
      vendorName: billData ? billData[0].vendorName : "",
      billId: billData ? billData[0].billId : "",
      billNumber: billData ? billData[0].billNo : "",
      billDate: billData ? new Date(billData[0].billDate) : "",
      expectedPaymentDate: billData
        ? new Date(billData[0].expectedPaymentDate)
        : "",
      branch: billData ? billData[0].branchCode : "",
      billReferenceNo: billData ? billData[0].billReferenceNo : "",
      vendorBranch: billData ? billData[0].vendorBranchCode : "",
      remarks: billData ? billData[0].remarks : "",
      isGstApplicable:
        billData && billData[0].isGstApplicable === 0 ? false : true,
      supportDoc: tempDocArray || [
        {
          supportingDocumentTypeId: "0",
          supportingDocumentTypeName: "",
          fileUrl: "",
          billId: "0",
        },
      ],
      fileUpload: "",
      fileSize: "",
      filePath: billData ? billData[0].filePath : "",
      billReceiptDate:
        billData && billData[0].billReceiptDate !== "01-01-1970"
          ? new Date(billData[0].billReceiptDate)
          : "",
      productDetails: [
        {
          productName: "",
          startDate: "",
          endDate: "",
          quantity: 1,
          rate: "",
          discount: "",
          discountType: "1",
          iGstPercent: 0,
          iGst: 0,
          cGstPercent: 0,
          cGst: 0,
          sGstPercent: 0,
          sGst: 0,
          amount: 0,
        },
      ],
      //activePODetails: activePOData,
      mappedPODetails:mappedPOData,
      finalAmount: "",
      mappedPOFinalAmount:'',
      activePOSelected: [],
    };

    const validateSchema = yup.object().shape({
      vendorName: yup.mixed().required("Partner Name is Required"),
      billDate: yup.mixed().required("Bill Date is Required"),
      branch: yup.mixed().required("Branch is Required"),
      expectedPaymentDate: yup
        .mixed()
        .required("Expected Payment Date is Required"),
      billReferenceNo: yup
        .mixed()
        .required("Bill Reference Number is Required"),
    });

    const onSubmit = (values, onSubmitProps) => {
      let supportingDocIds = [],
        supportingDocumentTypeName = [],
        billIDForDocument;
      if (values?.supportDoc?.length > 0) {
        values.supportDoc.forEach((element) => {
          if (element.isDeleted == 1) {
            billIDForDocument = element.billId.toString();
            supportingDocIds.push(element.supportingDocumentTypeId.toString());
            supportingDocumentTypeName.push(element.supportingDocumentTypeName);
          }
        });
      }
      if (supportingDocIds?.length > 0) {
        let payload = {
          customerNo: localStorage.getItem("customerNo"),
          userId: localStorage.getItem("userId"),
          billId: billIDForDocument,
          supportingDocumentTypeId: supportingDocIds,
        };

        Axios.delete(
          `${APP_CONSTANT.BASE_URL}purchase/bill/deleteBillSupportingDocumentType`,
          {
            data: payload,
            headers: {
              "Content-Type": "application/json;charset=UTF-8",
              "Access-Control-Allow-Origin": "*",
              Authorization: localStorage.getItem("apiToken"),
            },
          }
        )
          .then((res) => {
            cogoToast.success(
              "Deleted Document Ids: ",
              supportingDocumentTypeName.toString()
            );
            setTimeout(() => {
              window.location.reload();
            }, 2000);
          })
          .catch((err) => {
            cogoToast.error(
              "Error while deleting Document Ids: ",
              supportingDocumentTypeName.toString()
            );
          });
      }

      const customerNumber = localStorage.getItem("customerNo");
      const userId = localStorage.getItem("userId");

      let psLineItems = [];
      values.productDetails.map((product, index) => {
        let temp = {};
        temp.psCode = product.productCode;
        temp.psName = product.productName;
        temp.startDate = product.startDate;
        temp.endDate = product.endDate;
        temp.psQty = product.quantity;
        temp.psPrice = product.rate;
        temp.psAmount = product.rate * product.quantity;
        temp.igstPercent = product.iGstPercent;
        temp.igstAmount = product.iGst;
        temp.cgstPercent = product.cGstPercent;
        temp.cgstAmount = product.cGst;
        temp.sgstPercent = product.sGstPercent;
        temp.sgstAmount = product.sGst;
        temp.tdsCode = 9;
        temp.discount = product.discount;
        temp.finalDiscount = product.discount;
        temp.discountType = product.discountType;
        temp.taxableAmount = product.rate * product.quantity;
        psLineItems[index] = temp;
      });
      let mappedPOArray = []
      billData && billData[0].bill_po_mapping.map((object, ind) => {
        let temp ={}
        temp.poReferenceNo = object.po_details.poReferenceNo;
        mappedPOArray[ind] = temp

      })
      let tempArray = mappedPOArray.concat(values.activeSOSelected)
      let exLineItems = [];
      tempArray.map((product, index) => {
        let temp = {};
        temp.poReferenceNo = product.poReferenceNo;
        exLineItems[index] = temp;
      });

      let manualPoArray = [
        {
          poReferenceNo: values.poReferenceNo,
          vendorCode: values.vendorName,
          branchCode: values.vendorBranch,
          vehicleNo: values.vehicleNumber,
          poQuantity: psLineItems?.length,
          poAmount: values.finalAmount,
          sgstAmount: 0,
          cgstAmount: 0,
          igstAmount: 0,
          adjustment: 0,
          totalOrderAmt: values.finalAmount,
          remarks: values.remarks,
          gstTaxType: 0,
          poDate: new Date(),
          tdsAmount: 0,
          taxableAmount: values.finalAmount,
          totalDiscount: 0,
          psDetails: psLineItems,
        },
      ];

      if (activateManualPO) {
        exLineItems = [];
      } else {
        manualPoArray = [];
      }

      let supportingDocArray = [];
      values.supportDoc.map((document, documentIndex) => {
        let temp = {};
        temp.supportingDocumentTypeName = document.supportingDocumentTypeName;
        temp.supportingDocumentTypeId = document.supportingDocumentTypeId;
        return (supportingDocArray[documentIndex] = temp);
      });

      const updateBillData = {
        customerNo: customerNumber,
        userId: userId,
        vendorCode: billData[0].vendorCode,
        vendorName: billData[0].vendorName,
        billAmount:+values.finalAmount + +(values.activeSOSelected?.length > 0 && Number(values.activeSOSelected.map(item => item.poAmount).reduce((prev, next) => parseInt(prev) + parseInt(next))).toFixed(2)),
        statusCode: "",
        fileUpload: values.fileUpload && values.fileUpload.base64.split(",")[1],
        expectedPaymentDate: moment(values.expectedPaymentDate).format(
          "DD-MM-YYYY"
        ),
        billReferenceNo: values.billReferenceNo,
        billDate: moment(values.billDate).format("DD-MM-YYYY"),
        totalPoAmount: +values.finalAmount +  +(values.activeSOSelected?.length > 0 && Number(values.activeSOSelected.map(item => item.poAmount).reduce((prev, next) => parseInt(prev) + parseInt(next))).toFixed(2)),
        termsConditions: "",
        remarks: values.remarks,
        branchCode: values.branch,
        vendorBranchCode: values.vendorBranch,
        gstTaxType: 2,
        totalTaxableAmount: 0,
        totalSgstAmount: 2,
        totalCgstAmount: 2,
        totalIgstAmount: 2,
        totalTdsAmount: 2,
        departMentCategoryCode: 0,
        irn: "",
        hsnCode: "",
        noOfLineItems: psLineItems.length,
        isPartialBill: 0,
        grn: "",
        grnDateTime: "",
        billReceiptDate: moment(values.billReceiptDate).format("DD-MM-YYYY"),
        poDate: "",
        totalOrderAmt:+values.finalAmount +  +(values.activeSOSelected?.length > 0 && Number(values.activeSOSelected.map(item => item.poAmount).reduce((prev, next) => parseInt(prev) + parseInt(next))).toFixed(2)),
        adjustment: 0,
        poAmount:values.amount + tempArray?.length > 0 && Number(tempArray.map(item => item.poAmount).reduce((prev, next) => parseInt(prev) + parseInt(next))).toFixed(2),
        poQuantity: 1,
        tdsAmount: "",
        taxableAmount: 2,
        totalDiscount: 0,
        isGstApplicable: values.isGstApplicable ? "1" : "0",
        existingPoArray: exLineItems,
        manualPoArray: manualPoArray,
        supportingDocumentTypeArray: supportingDocArray,
      };

      updateBill(updateBillData).then(() => {
        setTimeout(() => {
          onSubmitProps.setSubmitting(false);
        }, 4000);
      });
    };

    const handleDownload = () => {
      window.open(billData[0].filePath);
    };

    const getVendorDetails = (childData) => {
      setVendorDetails(childData);
    };

    const getBranchData = (childData) => {
      setBranchData(childData);
    };

    const getBranchSelected = (childData) => {
      const branchDetails = vendorDetails.branches.find(
        (data) => data.vendorBranchCode === childData
      );
      const stateDetails = stateData.find(
        (data) => data.stateId === branchDetails.vendorBranchStateId
      );

      setGst(branchDetails.vendorBranchGST);
      setVendorState(stateDetails.state);
      setVendorStateId(stateDetails.stateId);
      setBranchCode(branchDetails.vendorBranchCode);
    };

    const getMasterBranchSelected = (branchCode, branchData) => {
      const addedMasterBranchObject = branchData?.find(
        (data) => data?.branchCode === branchCode
      );
      setMasterState(addedMasterBranchObject?.stateId);
    };

    return (
      <React.Fragment>
        <AddTitleBar title="Edit Bill" LinkName="/bill" />
        <div className="m-2">
          <Formik
            enableReinitialize={true}
            initialValues={initialValues}
            validationSchema={validateSchema}
            onSubmit={onSubmit}
          >
            {({ touched, errors, values, isSubmitting, handleSubmit }) => {
              const { mappedPODetails, productDetails, manualPoAddedTotal } =
                values;

              let tempPoAmount = [];
              let selectedPO = [];
              let mappedPOAmount = []

              activePOData.filter((item) => {
                if (item?.checkbox === true) {
                  if (values.isGstApplicable) {
                    tempPoAmount.push(item.poAmount);
                    selectedPO.push(item);
                  } else {
                    tempPoAmount.push(item.taxableAmount);
                    selectedPO.push(item);
                  }
                }
              });
              mappedPODetails.filter((item) => {
                if (item?.checkbox === true) {
                  if (values.isGstApplicable) {
                    mappedPOAmount.push(item.poAmount);
                    tempPoAmount.push(item.poAmount);
                    selectedPO.push(item);
                  } else {
                    mappedPOAmount.push(item.taxableAmount);
                    tempPoAmount.push(item.taxableAmount);
                    selectedPO.push(item);
                  }
                }
              })
              console.log(selectedPO,'selectedPO')
              values.activePOSelected = selectedPO;
              values.finalAmount = billData?.[0]?.billAmount
              
                values.mappedPOFinalAmount = billData?.[0]?.billAmount

              values.fileSize =
                values.fileUpload && values.fileUpload.fileList
                  ? values.fileUpload.fileList[0].size
                  : "";

              return (
                <>
                  <Segment>
                    <div className="ui form tiny">
                      <FormUi.Group>
                        <FormUi.Field width="4">
                          <label className="labelName mt-2">Partner Name</label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                        <div className='mt-2'>{values.vendorName}</div>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <label className="labelName mt-2">
                            Partner Branch
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik
                            component={PurchaseOrderBranchDropdown}
                            name="vendorBranch"
                            getBranchSelected={getBranchSelected}
                            branchData={branchData}
                            value={values.vendorBranch}
                            vendorId={values.vendorId}
                            vendorBranchCode={values.vendorBranch}
                            setBranchData={setBranchData}
                            setVendorDetails={setVendorDetails}
                          />
                          {touched.vendorBranch && errors.vendorBranch ? (
                            <strong className="w3-text-red w3-tiny font-weight-bold">
                              {errors.vendorBranch}
                            </strong>
                          ) : (
                            ""
                          )}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group>
                        <FormUi.Field width="4">
                          <label className="labelName mt-2">Bill Date</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <DateData
                            name={`billDate`}
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat="dd-MM-yyyy"
                            placeholderText="Date"
                            selected={values.billDate}
                            maxDate={new Date()}
                            minDate={hasMinValueForBillDate ? new Date(moment().subtract(45, 'days')) : null}
                            timeIntervals={5}
                            customInput={
                              <FormUi.Input
                                error={values.billDate ? false : true}
                                autoComplete="off"
                                className="dateWidth"
                                icon="time"
                                iconPosition="left"
                              />
                            }
                          />
                          {touched.billDate && errors.billDate ? (
                            <strong className="w3-text-red w3-tiny font-weight-bold">
                              {errors.billDate}
                            </strong>
                          ) : (
                            ""
                          )}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName mt-2">Branch</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik
                            disabled
                            component={BranchDropdown}
                            name="branch"
                            placeholder="Branch"
                            value={values.branch}
                            getMasterBranchSelected={getMasterBranchSelected}
                            masterBranchCode={values.branch}
                          />
                          {touched.branch && errors.branch ? (
                            <strong className="w3-text-red w3-tiny font-weight-bold">
                              {errors.branch}
                            </strong>
                          ) : (
                            ""
                          )}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group>
                        <FormUi.Field width="4">
                          <label className="labelName mt-2">
                            Expected Payment Date
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <DateData
                            name={`expectedPaymentDate`}
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat="dd-MM-yyyy"
                            placeholderText="Date"
                            selected={values.expectedPaymentDate}
                            minDate={values.billDate}
                            timeIntervals={5}
                            customInput={
                              <FormUi.Input
                                autoComplete="off"
                                className="dateWidth"
                                icon="time"
                                iconPosition="left"
                              />
                            }
                          />
                          {touched.expectedPaymentDate &&
                            errors.expectedPaymentDate ? (
                            <strong className="w3-text-red w3-tiny font-weight-bold">
                              {errors.expectedPaymentDate}
                            </strong>
                          ) : (
                            ""
                          )}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName mt-2">
                            Bill Reference Number
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik
                            name="billReferenceNo"
                            disabled
                            placeholder="Reference Number"
                            value={values.billReferenceNo}
                          />
                          {touched.billReferenceNo && errors.billReferenceNo ? (
                            <strong className="w3-text-red w3-tiny font-weight-bold">
                              {errors.billReferenceNo}
                            </strong>
                          ) : (
                            ""
                          )}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group>
                        <FormUi.Field width="4">
                          <label className="labelName mt-2">
                            Bill Receipt Date
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <DateData
                            name={`billReceiptDate`}
                            autoComplete="off"
                            popperClassName="dateTime"
                            dateFormat="dd-MM-yyyy"
                            placeholderText="Date"
                            selected={values.billReceiptDate}
                            minDate={new Date()}
                            timeIntervals={5}
                            customInput={
                              <FormUi.Input
                                autoComplete="off"
                                className="dateWidth"
                                icon="time"
                                iconPosition="left"
                              />
                            }
                          />
                          {touched.billReceiptDate && errors.billReceiptDate ? (
                            <strong className="w3-text-red w3-tiny font-weight-bold">
                              {errors.billReceiptDate}
                            </strong>
                          ) : (
                            ""
                          )}
                        </FormUi.Field>
                        <FormUi.Field width="1" />

                        <FormUi.Field width="3">
                          <label className="labelName mt-2">
                            {values.filePath
                              ? "Re Upload Invoice"
                              : "Upload Invoice"}
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width={values.fileSize ? "4" : "3"}>
                          <Fieldmik
                            component={UploadFile}
                            name="fileUpload"
                            size="tiny"
                            typer={[".pdf"]}
                            value={values.fileUpload}
                            buttonName={
                              values.fileUpload ? "Selected" : "Select"
                            }
                          />
                          {/* {touched.fileUpload && errors.fileUpload ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.fileUpload}</strong> : ''} */}
                          {values.fileUpload ? (
                            <strong className="w3-text-green w3-tiny font-weight-bold">
                              {values.fileUpload.fileList[0].name}
                            </strong>
                          ) : (
                            ""
                          )}
                          <br />
                          {values.fileSize && values.fileSize >= 5000000 ? (
                            <strong className="w3-text-red w3-tiny font-weight-bold">
                              File size should be less than 5MB
                            </strong>
                          ) : (
                            ""
                          )}
                        </FormUi.Field>
                        <FormUi.Field>
                          {values.filePath ? (
                            <Button
                              onClick={handleDownload}
                              type="button"
                              color="blue"
                              size="tiny"
                              icon="download"
                              basic
                            ></Button>
                          ) : (
                            ""
                          )}
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group>
                        <FormUi.Field width="4">
                          <label className="labelName mt-2">Bill Number</label>
                        </FormUi.Field>
                        <FormUi.Field width="3">
                          <Fieldmik
                            name="billNumber"
                            placeholder="Bill Number"
                            readOnly
                          />
                          {touched.billNumber && errors.billNumber ? (
                            <strong className="w3-text-red w3-tiny font-weight-bold">
                              {errors.billNumber}
                            </strong>
                          ) : (
                            ""
                          )}
                        </FormUi.Field>
                        <FormUi.Field width="1" />
                        <FormUi.Field width="3">
                          <label className="labelName mt-2">
                            Is GST Applicable?
                          </label>
                        </FormUi.Field>
                        <FormUi.Field className="mt-2">
                          <Checkbox
                            name={`isGstApplicable`}
                            value={values.isGstApplicable}
                          />
                        </FormUi.Field>
                      </FormUi.Group>
                      <FormUi.Group>
                        <FormUi.Field width="3">
                          <label className="labelName mt-2">
                            Remarks
                          </label>
                        </FormUi.Field>
                        <FormUi.Field width="4">
                          <Fieldmik component={MyTextArea} name="remarks" placeholder="remarks" />
                          {touched.remarks && errors.remarks ? <strong className="w3-text-red w3-tiny font-weight-bold">{errors.remarks}</strong> : ''}
                        </FormUi.Field>
                      </FormUi.Group>
                    </div>
                  </Segment>

                  <Segment compact>
                    <SupportingDoc editMode={true} />
                  </Segment>

                  <Segment>
                    <div className="ui form tiny">
                      <Button
                        type="button"
                        onClick={() => {
                          setActivateManualPO(false);
                        }}
                        style={{ borderRadius: "5px 5px 0px 0px" }}
                        size="small"
                        toggle
                        active={!activateManualPO}
                      >
                        Active Purchase Order
                      </Button>
                      {activateManualPO ? (
                        <>
                          <Container className="m-2">
                            <FormUi.Group>
                              <FormUi.Field width="3">
                                <label className="labelName mt-2">
                                  Vehicle Number
                                </label>
                              </FormUi.Field>
                              <FormUi.Field width="3">
                                <Fieldmik
                                  component={VendorVehicleDropdown}
                                  name="vehicleNumber"
                                  placeholder="Vehicle Number"
                                  vehicleData={vehicleData}
                                />
                                {touched.vehicleNumber &&
                                  errors.vehicleNumber ? (
                                  <strong className="w3-text-red w3-tiny font-weight-bold">
                                    {errors.vehicleNumber}
                                  </strong>
                                ) : (
                                  ""
                                )}
                              </FormUi.Field>
                              <FormUi.Field width="2" />
                              <FormUi.Field width="3">
                                <label className="labelName mt-2">
                                  PO Reference Number
                                </label>
                              </FormUi.Field>
                              <FormUi.Field width="3">
                                <Fieldmik
                                  name="poReferenceNo"
                                  placeholder="Reference Number"
                                />
                                {touched.poReferenceNo &&
                                  errors.poReferenceNo ? (
                                  <strong className="w3-text-red w3-tiny font-weight-bold">
                                    {errors.poReferenceNo}
                                  </strong>
                                ) : (
                                  ""
                                )}
                              </FormUi.Field>
                            </FormUi.Group>
                          </Container>

                          <AddProduct />
                        </>
                      ) : (
                          <>
                            {editMappedPOLoading ?
                              <React.Fragment>
                                <LoadingPlaceholder />
                              </React.Fragment>
                              :
                              <CheckedPurchaseOrder
                                editmode={true}
                                masterState={masterState}
                                vendorStateId={vendorStateId}
                                updatePurchaseOrder={updatePurchaseOrder}
                                getVendorPurchaseOrder={getVendorPurchaseOrder}
                                vendorData={vendorData}
                                purchaseOrderPaginationData={
                                  mappedPOPagination
                                }
                                handlePaginationChangeCall={handleMappedPOPaginationChange}
                                handleSearchStringCall={handleSearchString}
                                searchTextProps={searchText}
                                purchaseOrderCurrentPageData={
                                  mappedPurchaseOrderCurrentPage
                                }
                                billData={billData}
                              />}
                            {editLoading ?
                              <React.Fragment>
                                <LoadingPlaceholder />
                              </React.Fragment>
                              :
                              <ActivePurchaseOrder
                                editmode={true}
                                masterState={masterState}
                                vendorStateId={vendorStateId}
                                updatePurchaseOrder={updatePurchaseOrder}
                                getVendorPurchaseOrder={getVendorPurchaseOrder}
                                vendorData={vendorData}
                                purchaseOrderPaginationData={
                                  vendorPurchaseOrderPagination
                                }
                                handlePaginationChangeCall={handlePaginationChange}
                                handleSearchStringCall={handleSearchString}
                                searchTextProps={searchText}
                                purchaseOrderCurrentPageData={
                                  purchaseOrderCurrentPage
                                }
                                billData={billData}
                                activePOs={activePOData}
                              />}
                        </>
                      )}
                    </div>
                  </Segment>
                  <center>
                    <Button
                      style={{ marginBottom: "75px" }}
                      disabled={isSubmitting || billData?.[0] ? billData[0].isModuleFlag : false}
                      onClick={handleSubmit}
                      size="mini"
                      primary
                      type="submit"
                    >
                      Submit
                    </Button>
                  </center>
                </>
              );
            }}
          </Formik>
        </div>
      </React.Fragment>
    );
  // }
};

const mapStatetoProps = (state) => ({
  vendorPurchaseOrderData:
    state.getVendorPurchaseOrderData.vendorPurchaseOrder.data,
  vendorPurchaseOrderPagination:
    state.getVendorPurchaseOrderData.vendorPurchaseOrder.pagination,
  vendorPurchaseOrderLoading: state.getVendorPurchaseOrderData.isLoading,
  billData: state.getBillsData.bills.data,
  billLoading: state.getBillsData.isLoading,
});

export default connect(mapStatetoProps, {
  updateBill,
  getVendorPurchaseOrder,
  getBills,
  updatePurchaseOrder,
})(EditBill);
